<template>
  <div>
    <div v-if="components.nav_drawer.product_index==1&&components.nav_drawer.sub_product_index==0" style="height:300px;">
      <div><b>COVER AND ADDITIONAL BENEFITS.</b></div>
      <div style="padding:10px">
        <v-row>
          <v-col
            cols="12"
            sm="6"
          >
              <div style="padding:10px 20px;background-color:beige;border-bottom: 1px solid #ccc;text-align:left">
                <h6><b>Cover</b></h6>
              </div>
              <div style="height:200px">
                <v-card
                  class="mx-auto"
                  max-width="600"
                  height="200"
                  tile
                >
                    <div style="font-size:16px;text-align:left;padding-left:20px;padding-top:10px"><b>Accidental loss or damage including:</b></div>
                    <div style="font-size:14px;padding-left:40px;text-align:left">
                      Non Political Riot and Strike to insured vehicles
                    </div>
                    <div style="font-size:14px;padding-left:40px;text-align:left">
                      Indemnity against Third Party Legal Liability
                    </div>                    
                </v-card>
              </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
          >
            <div style="padding:10px 20px;background-color:beige;border-bottom: 1px solid #ccc;text-align:left">
              <h6><b>Additional Benefits</b></h6>
            </div>
            <div style="height:200px">
              <v-card
                  class="mx-auto"
                  max-width="600"
                  height="200"
                  tile
                >
                  <div style="font-size:14px;padding-left:20px;text-align:left;padding-top:10px">
                    Personal Effects - K2,000
                  </div>
                  <div style="font-size:14px;padding-left:20px;text-align:left">
                    Medical Expenses - K5,000
                  </div>
                  <div style="font-size:14px;padding-left:20px;text-align:left">
                    Loss of Keys - K1,000
                  </div>
                  <div style="font-size:14px;padding-left:20px;text-align:left">
                    Undeclared Radios/Equipment - K1,000
                  </div>
                  <div style="font-size:14px;padding-left:20px;text-align:left">
                    Towing Charges - K1,000
                  </div>
                  <div style="font-size:14px;padding-left:20px;text-align:left">
                    Authorised/Unauthorised passengers - Incl. in Third Party Liability
                  </div>
                </v-card>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <!--Motor Third Party-->
    <div v-else-if="components.nav_drawer.product_index==1&&components.nav_drawer.sub_product_index==1" style="height:300px;">
      <div><b>COVER AND ADDITIONAL BENEFITS.</b></div>
      <div style="padding:10px">
        <v-row>
          <v-col
            cols="12"
            sm="6"
          >
              <div style="padding:10px 20px;background-color:beige;border-bottom: 1px solid #ccc;text-align:left">
                <h6><b>Cover</b></h6>
              </div>
              <div style="height:200px">
                <v-card
                  class="mx-auto"
                  max-width="600"
                  height="200"
                  tile
                >
                    <div style="font-size:16px;text-align:left;padding-left:20px;padding-top:10px"><b>All sums including:</b></div>
                    <div style="font-size:14px;padding-left:40px;text-align:left">
                      Claimant's costs and expenses that the insured is legally liable
                    </div>
                    <div style="font-size:14px;padding-left:40px;text-align:left">
                      to pay due to death/injury to persons and/or damage to property
                    </div>                    
                </v-card>
              </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
          >
            <div style="padding:10px 20px;background-color:beige;border-bottom: 1px solid #ccc;text-align:left">
              <h6><b>Additional Benefits</b></h6>
            </div>
            <div style="height:200px">
              <v-card
                  class="mx-auto"
                  max-width="600"
                  height="200"
                  tile
                >
                  
                </v-card>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <!--House Owners-->
    <div v-else-if="components.nav_drawer.product_index==2" style="height:300px;">
      <div><b>COVER AND ADDITIONAL BENEFITS.</b></div>
      <div style="padding:10px">
        <v-row>
          <v-col
            cols="12"
            sm="6"
          >
              <div style="padding:10px 20px;background-color:beige;border-bottom: 1px solid #ccc;text-align:left">
                <h6><b>Cover</b></h6>
              </div>
              <div style="height:200px">
                <v-card
                  class="mx-auto"
                  max-width="600"
                  height="200"
                  tile
                >
                    <div style="font-size:16px;text-align:left;padding-left:20px;padding-top:10px"><b>Loss or damage to houses caused by:</b></div>
                    <div style="font-size:14px;padding-left:40px;text-align:left">
                      Fire Lightning Explosion, Earthquake, Riot and Strike,
                    </div>
                    <div style="font-size:14px;padding-left:40px;text-align:left;padding-right:10px">
                      Malicious Damage, Storm Tempest Flood, Aircraft and Other aerial devices,
                    </div> 
                    <div style="font-size:14px;padding-left:40px;text-align:left">
                      Bursting or Overflowing of water apparatus or pipes, 
                    </div>
                    <div style="font-size:14px;padding-left:40px;text-align:left;padding-right:10px">
                      Housebreaking, Theft or any attempt, thereat, Impact with the buildings.

                    </div>                   
                </v-card>
              </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
          >
            <div style="padding:10px 20px;background-color:beige;border-bottom: 1px solid #ccc;text-align:left">
              <h6><b>Additional Benefits</b></h6>
            </div>
            <div style="height:200px">
              <v-card
                  class="mx-auto"
                  max-width="600"
                  height="200"
                  tile
                >
                  <div style="font-size:14px;padding-left:20px;text-align:left;padding-top:10px">
                    Debris removal – K25,000
                  </div>
                  <div style="font-size:14px;padding-left:20px;text-align:left">
                    Malicious Damage – K10,000
                  </div>
                  <div style="font-size:14px;padding-left:20px;text-align:left">
                    Public Authorities clause  - K50,000
                  </div>
                  <div style="font-size:14px;padding-left:20px;text-align:left">
                    Architects and other professional fees clause – K10,000
                  </div>
                  <div style="font-size:14px;padding-left:20px;text-align:left">
                    Fire brigade charges clause – K10,000
                  </div>
                  <div style="font-size:14px;padding-left:20px;text-align:left">
                    Liability to domestic workers – K5,000
                  </div>
                </v-card>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <!--Overseas Travel-->
    <div v-else-if="components.nav_drawer.product_index==3" style="height:300px;">
      <div><b>COVER AND ADDITIONAL BENEFITS.</b></div>
      <div style="padding:10px">
        <v-row>
          <v-col
            cols="12"
            sm="6"
          >
              <div style="padding:10px 20px;background-color:beige;border-bottom: 1px solid #ccc;text-align:left">
                <h6><b>Cover</b></h6>
              </div>
              <div style="height:200px">
                <v-card
                  class="mx-auto"
                  max-width="600"
                  height="200"
                  tile
                >
                    <div style="font-size:14px;padding-left:20px;text-align:left;padding-top:5px">
                      Financial losses due to travel changes, cancellation or interruption, 
                    </div>
                    <div style="font-size:14px;padding-left:20px;text-align:left">
                      Medical expenses, baggage delays or theft, liability cover, accidental
                    </div>     
                    <div style="font-size:14px;padding-left:20px;text-align:left">
                      Death or disability and transportation delays.
                    </div>                    
                </v-card>
              </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
          >
            <div style="padding:10px 20px;background-color:beige;border-bottom: 1px solid #ccc;text-align:left">
              <h6><b>Additional Benefits</b></h6>
            </div>
            <div style="height:200px">
              <v-card
                  class="mx-auto"
                  max-width="600"
                  height="200"
                  tile
                >
                  
                </v-card>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
    <!--Muende Bwino-->
    <div v-else-if="components.nav_drawer.product_index==5" style="height:300px;">
      <div><b>COVER AND ADDITIONAL BENEFITS.</b></div>
      <div style="padding:10px">
        <v-row>
          <v-col
            cols="12"
            sm="6"
          >
              <div style="padding:10px 20px;background-color:beige;border-bottom: 1px solid #ccc;text-align:left">
                <h6><b>Cover</b></h6>
              </div>
              <div style="height:200px">
                <v-card
                  class="mx-auto"
                  max-width="600"
                  height="200"
                  tile
                >
                    <div style="font-size:14px;padding-left:20px;text-align:left;padding-top:5px">
                      Provides for cash compensation in the event of injury sustained 
                    </div>
                    <div style="font-size:14px;padding-left:20px;text-align:left">
                      as a result of a road traffic accident and medical expenses cover 
                    </div>  
                    <div style="font-size:14px;padding-left:20px;text-align:left">
                      for costs that may be incurred.
                    </div>                  
                </v-card>
              </div>
          </v-col>
          <v-col
            cols="12"
            sm="6"
          >
            <div style="padding:10px 20px;background-color:beige;border-bottom: 1px solid #ccc;text-align:left">
              <h6><b>Additional Benefits</b></h6>
            </div>
            <div style="height:200px">
              <v-card
                  class="mx-auto"
                  max-width="600"
                  height="200"
                  tile
                >
                  
                </v-card>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  //import axios from "axios";

  //const URL_COMP = "http://139.59.131.242:4000/comp/quotationsByClient";
  //const URL_FTP = "http://139.59.131.242:4000/tp/quotationsByClient";
  export default {
    data () {
      return {
        empty: true,
        headers: [
          {
            text: 'Date',
            align: 'left',
            sortable: false,
            value: 'created_at',
          },
          { text: 'Product', value: 'product_type_id' },
          { text: 'Start', value: 'start_date' },
          { text: 'Expiry', value: 'end_date' },
          { text: 'Premium', value: 'total_premium_due' },
          { text: 'Currency', value: 'currency' },
        ],
        quotes:[]
      }
    },
    methods: {
      openDrawer(){
        this.components.nav_drawer.product_index=0;
        this.components.nav_drawer.mini_variant=false;
        this.components.nav_drawer.expand_on_hover=false;
        this.closeSheet();
      },
      closeSheet(){
        this.components.bottom_sheet.is_open=false;
        this.components.bottom_sheet.option_index=0;
      }
    },
    created(){
      console.log(this.components.nav_drawer.product_index);
      /*const client_id = {
          id :this.user.data.client_id
      }

      //var URL = '';
      //console.log(client_id);
        
      axios
        .get(URL_FTP, { params:client_id })
        .then(response => {
          console.log(response);
          if (response.status == 200){
            this.quotes = response.data;
            this.empty = false;
          }
        })
        .catch(error => {
          console.log('Error', error);
        }); */
    },
    computed: {
      ...mapGetters({
        user: "user",
        components: "components"
      })
    }
  }
</script>